import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { getAuthState } from '../../features/auth/authSlice';
import { announcementsActions } from '../../store/announcements/action';
import { propertyTypologyActions } from '../../store/propertyTypologies/actions';
import { getPropertyTypologiesState } from '../../store/propertyTypologies/reducer';
import { useAppDispatch, useAppSelector } from '../redux/store';

function useInitApp() {
  const dispatch = useAppDispatch();
  const { isLogged, user } = useAppSelector(getAuthState);
  const { propertyTypologies } = useAppSelector(getPropertyTypologiesState);

  useEffect(() => {
    if (isLogged && user.result) {
      if (isEmpty(propertyTypologies)) {
        dispatch(propertyTypologyActions.fetchPropertyTypologies.request());
      }
      dispatch(announcementsActions.fetchAnnouncements.request());
    }
  }, [isLogged]);
}

export default useInitApp;
